import { render, staticRenderFns } from "./TitlePage.vue?vue&type=template&id=fcacee8e"
import script from "./TitlePage.vue?vue&type=script&lang=js"
export * from "./TitlePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../Development/graduation/graduate-frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports